import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=052fd3bc"
import script from "./BaseTextInput.vue?vue&type=script&lang=js"
export * from "./BaseTextInput.vue?vue&type=script&lang=js"
import style0 from "./BaseTextInput.vue?vue&type=style&index=0&id=052fd3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports